import { AuthorizationError, SpendingLimitPeriod } from "../types/common";
import { ApiSpendingLimitPeriod } from "../types/api";

const gridToProgram: Record<SpendingLimitPeriod, string> = {
    one_time: "one_time",
    daily: "day",
    weekly: "week",
    monthly: "month",
};

export function gridToProgramPeriod(period: SpendingLimitPeriod): ApiSpendingLimitPeriod {
    const mapped = gridToProgram[period];
    if (!mapped) throw new AuthorizationError("Invalid period", "INVALID_REQUEST");
    return mapped as ApiSpendingLimitPeriod;
}